module.exports = __webpack_public_path__ + "static/pool-ae6c1a0eb78ab2c60d595056b4120e47.png";